import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";

import PrimeVue from "primevue/config";
// import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
// import "primeicons/primeicons.css";
// import "primeflex/primeflex.css";

import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import InputMask from "primevue/inputmask";
import Button from "primevue/button";
import Chip from "primevue/chip";
import Message from "primevue/message";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Sidebar from "primevue/sidebar";
import Card from "primevue/card";
import InputNumber from "primevue/inputnumber";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import ToastService from "primevue/toastservice";
import { localePT } from "./utils/constants";

Vue.config.productionTip = false;
Vue.use(Vuelidate);

Vue.use(PrimeVue ,{
  locale : localePT
});
Vue.use(ToastService);

Vue.component("InputText", InputText);
Vue.component("InputMask", InputMask);
Vue.component("Button", Button);
Vue.component("Chip", Chip);
Vue.component("Message", Message);
Vue.component("Dropdown", Dropdown);
Vue.component("Calendar", Calendar);
Vue.component("Sidebar", Sidebar);
Vue.component("Card", Card);
Vue.component("Textarea", Textarea);
Vue.component("InputNumber", InputNumber);
Vue.component("Dialog", Dialog);
Vue.component('DataTable', DataTable);
Vue.component('Column', Column);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
